import { render } from "./CurrentAccountView.vue?vue&type=template&id=1a3dee4e"
import script from "./CurrentAccountView.vue?vue&type=script&lang=js"
export * from "./CurrentAccountView.vue?vue&type=script&lang=js"

import "./CurrentAccountView.vue?vue&type=style&index=0&id=1a3dee4e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__